export default "__VITE_ASSET__COf_hLNm__"